import { render, staticRenderFns } from "./ip-whitelisting.vue?vue&type=template&id=545f4093"
import script from "./ip-whitelisting.vue?vue&type=script&lang=js"
export * from "./ip-whitelisting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports